import initMobileMenu from './mobile-menu';
import initHeaderFooter from './header-footer';

export default function initNavigation() {
    initHeaderFooter();
    initMobileMenu();
}
